module.exports = __webpack_public_path__ + "static/media/Role-id-master.81c163e2.xls";